var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.images),function(image){return _c('div',{key:image._key},[_c('Media',{attrs:{"image":image}},[_vm._t("default",null,{"image":image})],2)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }